define('../app/fukit/behavior/navigate.on.event.behavior',['require','exports','module','underscore','backbone','marionette','../helpers/route.helper','appkit/util/key.prefixer','backbone.radio'],function(require, exports, module) {
  //prettier-ignore
  var _           = require('underscore'),
      Backbone    = require('backbone'),
      Mn          = require('marionette'),
      RouteHelper = require('../helpers/route.helper'),
      KeyPrefixer = require('appkit/util/key.prefixer'),
      Radio       = require('backbone.radio');

  var NavigateOnEventBehavior = Mn.Behavior.extend({
    defaults: {
      // This method is called at the beginning of the onEvent method.  If preventOnEventHandler
      //  returns true, the rest of onEvent doesn't run.
      // The default allows onEvent to run always.
      preventOnEventHandler: function() {
        return false;
      },

      // event that will trigger navigation
      // event source = view
      eventName: 'press',

      // pass specific model to the behavior
      model: null,

      // when true, will attempt to resolve model from event arguments
      // by searching for first argument of type Backbone.Model
      resolveModelFromEventArguments: false,

      // function that will resolve the model
      // this function will be called with event arguments
      modelResolver: null,

      // route to navigate to
      routeName: 'details',

      // route params with unresolved values
      routeParams: { id: '@model.id' },

      // navigation options (see Backbone navigate for more details)
      trigger: true,
      replace: false,
    },

    initialize: function() {
      this.listenTo(this.view, this.getOption('eventName'), this.onEvent);
    },

    getModel: function() {
      if (this.getOption('model')) {
        return this.getOption('model');
      } else if (_.isFunction(this.getOption('modelResolver'))) {
        return this.getOption('modelResolver').apply(this, this.eventArgs);
      } else if (this.getOption('resolveModelFromEventArguments')) {
        return _.find(this.eventArgs, function(arg) {
          return arg instanceof Backbone.Model;
        });
      } else {
        return this.view.model;
      }
    },

    onEvent: function() {
      var preventOnEventHandler = this.getOption('preventOnEventHandler');
      if (preventOnEventHandler.bind(this)()) {
        return;
      }
      this.eventArgs = _.toArray(arguments);
      this.navigate();
    },

    navigate: function() {
      var params = this.resolveRouteParams(this.getOption('routeParams'));
      RouteHelper.navigate(this.getOption('routeName'), params, {
        trigger: this.getOption('trigger'),
        replace: this.getOption('replace'),
      });
    },

    resolveRouteParams: function(params) {
      //prettier-ignore
      var state = Radio.channel('AppKit.controllerService').request('state'),
          model = this.getModel();
      var resolvedParams = {};

      _.each(
        params,
        function(param, key) {
          var resolvedFunctionParam = Mn._getValue(param, this);
          resolvedParams[key] = resolvedFunctionParam;
        },
        this
      );

      return KeyPrefixer.resolve(resolvedParams, {
        '@state.': function(stateKey) {
          if (state) {
            return state.get(stateKey);
          }
        },
        '@model.': function(modelKey) {
          if (model) {
            return model.get(modelKey);
          }
        },
      });
    },
  });

  module.exports = NavigateOnEventBehavior;
});

